import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MultiSelectDropdown from "../multidropdown";
import { useRouter } from "next/router";
import { useTranslation, Trans } from "next-i18next";
import "../../../styles/scss/contact-us.module.scss";
import "../../../styles/scss/comparison.module.scss";
import Link from "next/link";

let isValidInputs = true;
const ComparisonForm = (props: { title: string, label: string, formId: string; description?: string; isDatadog?: boolean; formDataComparison?: any; docsLink?: string }) => {
    const { t } = useTranslation("common");
    let isValidInputs = true;
    const [email, setEmail] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [company, setCompany] = useState("");
    const [companyErr, setCompanyErr] = useState(false);
    const [amount, setAmount] = useState(0);
    const [amountErr, setAmountErr] = useState(false);
    const [monitoringUseCase, setMonitoringUseCase] = useState("");
    const [errorMonitoringUseCase, setErrorMonitoringUseCase] = useState(false);
    const [message, setMessage] = useState("");
    const [messageErr, setMessageErr] = useState(false);
    const [querySent, setQuerySent] = useState(false);
    const [querySentText, setQuerySentText] = useState("");
    const router = useRouter();

    const formData = t('comparison.form', { returnObjects: true }) as any;
    const featuresData = Array.isArray(formData?.features) ? formData.features : [];

    useEffect(() => {
        setQuerySentText(t('comparison.form.successMessage'));
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        validateInputs();
        if (isValidInputs) {
            var xhr = new XMLHttpRequest();
            var url =
                "https://api.hsforms.com/submissions/v3/integration/submit/25310090/" + props.formId;
            var data = {
                submittedAt: Date.now(),
                fields: [
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "company",
                        value: company,
                    },
                    {
                        name: "message",
                        value: message,
                    },
                    {
                        name: "monitoring_use_case",
                        value: monitoringUseCase,
                    },
                    {
                        name: "monthly_amount",
                        value: amount,
                    },
                    {
                        name: "source_type",
                        value: props.label + t('comparison.form.sourceTypeSuffix'),
                    },
                ],
            };
            var final_data = JSON.stringify(data);
            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    setEmail("");
                    setCompany("");
                    setAmount(0)
                    setMessage("");
                    setMonitoringUseCase("")
                    setQuerySentText(t('comparison.form.successMessage'));
                    setQuerySent(true);
                    setTimeout(() => {
                        setQuerySent(false);
                    }, 6000);
                    // setTimeout(() => {
                    //     router.push("/thank-you");
                    // }, 1000);

                    // Returns a 200 response if the submission is successful.
                } else if (xhr.readyState == 4 && xhr.status == 400) {
                    setQuerySentText(xhr.responseText || t('comparison.form.successMessage'));
                } else if (xhr.readyState == 4 && xhr.status == 403) {
                    setQuerySentText(xhr.responseText || t('comparison.form.successMessage'));
                }
            };
            xhr.send(final_data);
        }
    };
    const validateInputs = () => {

        const emailRegEx =
            /^[\w-.]+@(?!gmail\.com$|yahoo\.com$|hotmail\.com$|yahoo\.co\.in$|aol\.com$|abc\.com$|xyz\.com$|pqr\.com$|rediffmail\.com$|live\.com$|outlook\.com$|me\.com$|msn\.com$|ymail\.com$)[\w-]+\.[a-zA-Z]{2,}$/;

        let emailId = email;
        let isInvalidEmail =
            emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase());
        let isInvalidAmount = amount < 0;
        let isInvalidSubject = company.length < 1;
        let isInvalidUsageCase = monitoringUseCase.length < 1;
        let isInvalidMessage = message.length < 3;
        // let isInvalidPhone = phone.length < 3 || !phoneRegEx.test((phone).toLowerCase())

        if (isInvalidEmail) {
            setEmailErr(true);
        }
        if (isInvalidAmount) {
            setAmountErr(true);
        }
        if (isInvalidSubject) {
            setCompanyErr(true);
        }
        if (isInvalidUsageCase) {
            setErrorMonitoringUseCase(true);
        }
        if (isInvalidMessage) {
            setMessageErr(true);
        }
        isValidInputs =
            !isInvalidEmail &&
            !isInvalidAmount &&
            !isInvalidSubject &&
            !isInvalidUsageCase &&
            !isInvalidMessage;
    };

    return (
        <div className={"comparison-form contact-form"}>
            <div className={"container"}>
                <div className={"d-flex"}>
                    <div className={"left-block"}>
                        <div className={"heading"}>
                            <h2>
                                You Don't Have to <span className="text-gradient">Rip Out</span> {props.label} on Day One
                            </h2>
                            {props.description && <p>{props.description}</p>}


                            {props.isDatadog && <div className="form-data-comparison">
                                {props.formDataComparison.map((item: any) => (
                                    <div key={item.id} className="d-flex">
                                        {item.icon}
                                        <p>{item.header}</p>
                                    </div>
                                ))}
                            </div>}

                            {props.docsLink && <Link href={props.docsLink} target="_blank" className="read-more" rel="noopener noreferrer">Read the Migration Docs</Link>}

                        </div>
                        {!props.isDatadog && <img src={"/images/comparison/middleware-comparison.svg"} alt={t('comparison.form.imageAlt')} width={100} height={100} />}
                    </div>
                    <div className={"right-block"}>
                        <div className={"form"}>
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className={"d-flex"}>
                                    <div className={"input-wrapper"}>
                                        <label>{t('comparison.form.fields.businessEmail.label')}</label>
                                        <br />
                                        <input
                                            type={"text"}
                                            value={email}
                                            placeholder={t('comparison.form.fields.businessEmail.placeholder')}
                                            className={`${emailErr ? "is-error contact-input" : "contact-input"
                                                }`}
                                            onChange={(e) => {
                                                const value = e.target && e.target.value;
                                                setEmail(value);
                                            }}
                                            onKeyUp={(e) => {
                                                if (email.length > 0) {
                                                    setEmailErr(false);
                                                }
                                            }}
                                        />
                                        <h6
                                            className={`form-input-validation ${emailErr ? "error" : ""}`}
                                        >
                                            {email.length < 1
                                                ? t('comparison.form.fields.businessEmail.errors.required')
                                                : t('comparison.form.fields.businessEmail.errors.invalid')}
                                        </h6>
                                    </div>
                                    <div className={"input-wrapper"}>
                                        <label>{t('comparison.form.fields.companyName.label')}</label>
                                        <br />
                                        <input
                                            type={"text"}
                                            value={company}
                                            placeholder={t('comparison.form.fields.companyName.placeholder')}
                                            className={`${companyErr ? "is-error contact-input" : "contact-input"
                                                }`}
                                            onChange={(e) => {
                                                const value = e.target && e.target.value;
                                                setCompany(value);
                                            }}
                                            onKeyUp={(e) => {
                                                if (company.length > 0) {
                                                    setCompanyErr(false);
                                                }
                                            }}
                                        />
                                        <h6
                                            className={`form-input-validation ${companyErr ? "error" : ""}`}
                                        >
                                            {t('comparison.form.fields.companyName.error')}
                                        </h6>
                                    </div>
                                </div>
                                <div className={"input-wrapper"}>
                                    <label>{t('comparison.form.fields.monthlySpends.label')}</label>
                                    <br />
                                    <input
                                        type={"number"}
                                        value={amount}
                                        placeholder={t('comparison.form.fields.monthlySpends.placeholder')}
                                        className={`${amountErr ? "is-error contact-input" : "contact-input"
                                            }`}
                                        onChange={(e) => {
                                            const value = e.target && e.target.value;
                                            // @ts-ignore
                                            setAmount(value);
                                        }}
                                        onKeyUp={(e) => {
                                            if (amount > 0) {
                                                setAmountErr(false);
                                            }
                                        }}
                                    />
                                    <h6
                                        className={`form-input-validation ${amountErr ? "error" : ""}`}
                                    >
                                        {t('comparison.form.fields.monthlySpends.error')}
                                    </h6>
                                </div>

                                <div className={"input-wrapper"}>
                                    <MultiSelectDropdown
                                        items={featuresData}
                                        // defaultSelectedItemIndex={0}
                                        onChange={(selectedItems) => {
                                            const selectedValuesString = selectedItems.map(item => item.value).join(', ');
                                            setMonitoringUseCase(selectedValuesString);
                                        }}
                                        className={errorMonitoringUseCase}
                                        placeholder={t('comparison.form.fields.featuresUsed.placeholder', { title: props.label })}
                                        label={t('comparison.form.fields.featuresUsed.label', { title: props.label })}
                                    />
                                    <h6
                                        className={`form-input-validation ${errorMonitoringUseCase ? "error" : ""
                                            }`}
                                    >
                                        {t('comparison.form.fields.featuresUsed.error')}
                                    </h6>
                                </div>
                                <div className={"input-wrapper"}>
                                    <label>{t('comparison.form.fields.additionalComments.label')}</label>
                                    <br />
                                    <textarea
                                        value={message}
                                        placeholder={t('comparison.form.fields.additionalComments.placeholder')}
                                        className={`${messageErr ? "is-error contact-input" : "contact-input"
                                            }`}
                                        onChange={(e) => {
                                            const value = e.target && e.target.value;
                                            setMessage(value);
                                        }}
                                        onKeyUp={(e) => {
                                            if (message.length > 0) {
                                                setMessageErr(false);
                                            }
                                        }}
                                    />
                                    <h6
                                        className={`form-input-validation ${messageErr ? "error" : ""
                                            }`}
                                    >
                                        {t('comparison.form.fields.additionalComments.error')}
                                    </h6>
                                </div>

                                <button type={"submit"} className={"primary arrow"}>
                                    {t('comparison.form.button')}
                                </button>
                                {querySent && <h6 className={"success"}>{querySentText}</h6>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
ComparisonForm.propTypes = {
    title: PropTypes.string,
    formId: PropTypes.string,

};
export default ComparisonForm;